module.exports = __webpack_public_path__ + "img/MapPicsWildwoods.b6d0e9a6.webp";